import { render, staticRenderFns } from "./ProfessionalActivityTaxonomyItem.vue?vue&type=template&id=69a59d65&scoped=true&"
import script from "./ProfessionalActivityTaxonomyItem.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalActivityTaxonomyItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProfessionalActivityTaxonomyItem.vue?vue&type=style&index=0&id=69a59d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a59d65",
  null
  
)

export default component.exports